import { FC } from 'react'
import { Box } from '@mui/material'

export const Mamoru: FC = () => {
  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',
        position: 'fixed',
        top: 0,
        left: 0,
      }}
    >
      <iframe
        src="https://support.medilabai.com/ebd/1d576a51b0c780f39c1ac35d01365afc"
        width="100%"
        height="100%"
        frameBorder="0"
        allowFullScreen
        style={{ border: 'none' }}
      />
    </Box>
  )
}
